import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  getEmployeePayrollDataError: {
    id: 'employee.payroll.getData.error',
    defaultMessage: 'Nie udało się pobrać danych dotyczących ewidencji czasu pracy za wybrany okres',
  },
});
